<!-- Reusa a tela de Fornecedores em modo embutido, sob contexto do cliente. -->
<app-fornecedores *ngIf="montado" [embutido]="true"></app-fornecedores>
